import React from "react";
import "./NoAttendanceConfirmation.css";

export const NoAttendanceConfirmation = () => {
  return (
    <section className="no-attendance-section ">
      <div className="no-attendance-content">
        <div className="no-attendance-title-wrapper">
          <span className="no-attendance-title">Gracias por</span>
          <span className="no-attendance-subtitle">TU CONFIRMACIÓN</span>
        </div>

        <span className="no-attendance-message">
          Lamentamos muchísimo que no puedas acompañarnos, pero entendemos que
          se te será imposible asistir. Te agradecemos de corazón tu
          confirmación.
        </span>

        <span className="no-attendance-gallery-invite">
          Para que no te pierdas ningún detalle, mira la galería de nuestra boda
        </span>

        <div className="no-attendance-gallery-button">
          <a
            href="https://photos.app.goo.gl/5r5DbWY1uiyvd37XA"
            className="gallery-button-no-attendance"
            target="_blank"
          >
            VER GALERÍA
          </a>
        </div>
      </div>
    </section>
  );
};
